(function (angular) {
	'use strict';

	angular.module('PinMeTo.directives').directive('pmtEndOfPage', [
		'$window',
		'$timeout',
		function ($window, $timeout) {
			return {
				restrict: 'A',
				scope: {
					pmtEndOfPage: '<'
				},
				link: function (scope) {
					let currentDocHeight = 0;

					$window.addEventListener('scroll', endOfPage);

					// For Chrome https://stackoverflow.com/a/47684257
					$window.addEventListener(
						'mousewheel',
						e => {
							if (e.deltaY === 1) {
								e.preventDefault();
							}
						},
						{ passive: false }
					);

					function endOfPage() {
						let windowHeight =
							'innerHeight' in $window
								? $window.innerHeight
								: document.documentElement.offsetHeight;
						let docHeight = Math.max(
							document.body.scrollHeight,
							document.documentElement.scrollHeight,
							document.body.offsetHeight,
							document.documentElement.offsetHeight,
							document.body.clientHeight,
							document.documentElement.clientHeight
						);
						let windowBottom = windowHeight + $window.pageYOffset;

						if (windowBottom >= docHeight * 0.8 && docHeight > currentDocHeight) {
							currentDocHeight = docHeight;
							$timeout(scope.pmtEndOfPage);
						}
					}
				}
			};
		}
	]);
})(window.angular);
